<template>
  <div class="productCertificate-container">
    <el-form :model="queryInfo" size="medium" :inline="true">
          <el-form-item :label="$t('finance.name39')" prop="tenantId">
              <el-cascader ref="refHandle" v-model="tenantIds" :placeholder="$t('public.name1')" :show-all-levels="false" @change="handleChange" :props="{ lazy: true, lazyLoad: loadOptions, checkStrictly: true }" clearable></el-cascader>
          </el-form-item>
          <el-form-item :label="$t('bike.name294')" prop="ebikeId">
            <el-input v-model="queryInfo.ebikeId" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item>
          <el-form-item :label="$t('bike.name295')" prop="ebikeCode">
            <el-input v-model="queryInfo.ebikeCode" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item>
           <el-form-item :label="$t('bike.name2')" prop="ebikeModelId">
            <el-input v-model="queryInfo.ebikeModelId" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item>
          <el-form-item :label="$t('bike.name368')" prop="saleStatus" >
          <el-select v-model="queryInfo.saleStatus" :placeholder="$t('public.name1')" style="width:100%" clearable>
    <el-option
      v-for="item in saleStatusOptions"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
        </el-form-item>
          <el-form-item :label="$t('bike.name367')" prop="searchTime">
              <el-date-picker
            v-model="queryInfo.searchTime"
            type="daterange"
           value-format="yyyy-MM-dd"
            :range-separator="$t('public.name9')"
            :start-placeholder="$t('public.name10')"
            :end-placeholder="$t('public.name11')"
          >
          </el-date-picker>
          </el-form-item>
          <el-form-item >
          <el-button type="primary" size="medium" @click="getPageList">{{ $t('public.name3') }}</el-button>
          <el-button size="medium" @click="resetQuery">{{ $t('public.name4') }}</el-button>
          </el-form-item>
    </el-form>
    <div>
      <!-- <el-button type="primary" size="medium" @click="getPageList">{{ $t('manage.name60') }}</el-button> -->
      <!-- <el-button type="primary" size="medium" @click="importProductDialog">导入产品质量合格证</el-button> -->
      <!-- <el-button type="primary" size="medium" @click="showAddIotNum">{{ $t('bike.name156') }}</el-button> -->
      <el-button type="primary" size="medium" @click="importBikeFactoryDialog" v-if="buttonPerms.indexOf('zBike/importVehicleFactoryInformation') > -1">{{ $t('bike.name400') }}</el-button>
      <el-button type="primary" size="medium" @click="importEditEbikeInfo" v-if="buttonPerms.indexOf('bike/importEditEbikeInfo') > -1">{{ $t('bike.name402') }}</el-button>
      <el-button type="primary" size="medium" @click="exportVehicle" :loading="loadingVehicle">{{ $t('bike.name529') }}</el-button>
      <el-button type="primary" size="medium" @click="exportCcc" :loading="loading">{{ $t('bike.name369') }}</el-button>
    </div>
    <el-table ref="certificateTable" :row-key="getCertificateRowKey" :data="tableList" :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }" v-loading='tableLoading' @selection-change="onSelectTab">
      <el-table-column type="selection" width="55" align="center" fixed="left" :reserve-selection="true"></el-table-column>
      <el-table-column :label="$t('finance.name40')" prop="tenantName" sortable> </el-table-column>
      <el-table-column :label="$t('bike.name278')" prop="ebikeCode" sortable></el-table-column>
      <el-table-column :label="$t('bike.name272')" prop="ebikeId" sortable></el-table-column>
      <!-- <el-table-column :label="$t('bike.name273')" prop="productName" sortable width="180px"></el-table-column> -->
      <el-table-column :label="$t('bike.name274')" prop="ebikeModelId" sortable></el-table-column>
      <!-- <el-table-column :label="$t('bike.name275')" prop="manufacturerTrademark" sortable width="220px"></el-table-column> -->
      <!-- <el-table-column :label="$t('bike.name276')" prop="manufacturingPlantAddress" sortable width="240px"></el-table-column> -->
      <!-- <el-table-column :label="$t('bike.name277')" prop="manufactureDate" sortable width="280px" ></el-table-column> -->
      <!-- <el-table-column :label="$t('bike.name279')" prop="motorCode" sortable width="180px" ></el-table-column> -->
      <!-- <el-table-column :label="$t('bike.name280')" prop="driveType" sortable width="150px" ></el-table-column> -->
      <!-- <el-table-column :label="$t('bike.name281')" prop="maxSpeed" sortable width="200px" ></el-table-column> -->
      <!-- <el-table-column :label="$t('bike.name282')" prop="ebikeQuality" sortable width="140px" ></el-table-column> -->
      <!-- <el-table-column :label="$t('bike.name283')" prop="powerVoltage" sortable width="280px" ></el-table-column> -->
      <!-- <el-table-column :label="$t('bike.name284')" prop="batteryType" sortable width="140px" ></el-table-column> -->
      <!-- <el-table-column :label="$t('bike.name285')" prop="lengthWidthHeight" sortable width="280px" ></el-table-column> -->
      <!-- <el-table-column :label="$t('bike.name286')" prop="beforeAfterWheelDistance" sortable width="360px" ></el-table-column> -->
      <!-- <el-table-column :label="$t('bike.name287')" prop="nameplateFixPosition" sortable width="220px" ></el-table-column> -->
      <!-- <el-table-column :label="$t('bike.name288')" prop="ebikeCodePosition" sortable width="200px" ></el-table-column> -->
      <!-- <el-table-column :label="$t('bike.name289')" prop="serviceLife" sortable width="200px" ></el-table-column> -->
      <!-- <el-table-column :label="$t('bike.name290')" prop="materialFlowLeaseManage" sortable width="370px" ></el-table-column> -->
      <el-table-column :label="$t('bike.name291')" prop="cccCode" sortable width="280px" ></el-table-column>
      <!-- <el-table-column :label="$t('bike.name292')" prop="engraveEbikeCode" sortable width="180px" ></el-table-column> -->
      <!-- <el-table-column :label="$t('bike.name293')" prop="certificateConformityUrl" sortable>
        <template slot-scope="scope">
          <el-image v-if="scope.row.certificateConformityUrl"  style="width: 40px; height: 40px" :src="scope.row.certificateConformityUrl" :preview-src-list="[scope.row.certificateConformityUrl]"></el-image>
        </template>
      </el-table-column> -->
      <!-- <el-table-column label="外观形状的左前方45°" prop="faultTime" width="100px" ></el-table-column>
      <el-table-column label="外观形状的右后方45°" prop="faultTime" width="100px" ></el-table-column>
      <el-table-column label="正面照片" prop="faultTime" width="120px" ></el-table-column>
      <el-table-column label="车头朝左侧面照片" prop="faultTime" width="110px" ></el-table-column> -->
      <el-table-column :label="$t('bike.name367')" prop="manufactureDate">
        <template slot-scope="scope">
          {{ scope.row.manufactureDate | tzDisplay }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('bike.name310')" prop="saleStatus" sortable>
        <template slot-scope="scope">
         {{ [$t('bike.name312'), $t('bike.name311')][scope.row.saleStatus] }}
        </template>
      </el-table-column>
      <!-- 销售时间：仅已售展示；前端截取 yyyy-MM-dd；无销售记录显示 -- -->
      <el-table-column :label="$t('bike.name458')" prop="saleDate" sortable width="160px">
        <template slot-scope="scope">
          <span v-if="scope.row.saleStatus === '1'">
            <!-- API 常带 HH:mm:ss，列表只要日期 -->
            <template v-if="scope.row.saleDate">{{ String(scope.row.saleDate).slice(0, 10) }}</template>
            <template v-else>--</template>
          </span>
        </template>
      </el-table-column>
      <!-- 海外：锁车状态（来自 keepalive.lockStatus）放在销售时间后 -->
      <el-table-column v-if="isOverseas" :label="$t('bike.name607')" prop="lockStatus" min-width="120">
        <template slot-scope="scope">
          {{ lockStatusLabel(scope.row.lockStatus) }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('bike.name11')" :width="isOverseas ? 220 : 300" fixed="right">
        <template slot-scope="scope">
          <!-- 详情：国内/海外均行外 -->
          <el-button type="text" @click="showDetailsDialog(scope.row)">{{ $t('bike.name46') }}</el-button>
          <!-- 海外行外：开关锁（0→开启远程锁定/remoteDisable/R1；非0→关闭远程锁定/remoteEnable/R2） -->
          <el-button
            v-if="isOverseas && canToggleLockFor(scope.row.lockStatus)"
            type="text"
            :disabled="isControlPending(scope.row.ebikeId)"
            @click="handleToggleLock(scope.row)"
          >{{ toggleLockLabel(scope.row.lockStatus) }}</el-button>
          <!-- 国内：IOT / 销售记录 / 维修仍在行外；海外：IOT、维修进三点 -->
          <template v-if="!isOverseas">
            <el-button type="text" @click="showIotDetailsDialog(scope.row)">IOT</el-button>
            <el-button type="text" @click="showSalesRecord(scope.row)" v-if="scope.row.saleStatus === '1'">{{ $t('tabmenu.name69') }}</el-button>
            <el-button type="text" @click="showMaintenanceRecord(scope.row)">{{ $t('tabmenu.name68') }}</el-button>
          </template>
          <!-- 海外：已售销售记录仍行外 -->
          <el-button
            v-if="isOverseas && scope.row.saleStatus === '1'"
            type="text"
            @click="showSalesRecord(scope.row)"
          >{{ $t('tabmenu.name69') }}</el-button>
          <!-- 海外三点：IOT、维修记录、解锁电池、锁定电池（无解绑配件） -->
          <el-dropdown
            v-if="isOverseas && showOverseasMoreMenu"
            trigger="click"
            placement="bottom-end"
            @command="handleOverseasMenuCommand($event, scope.row)"
          >
            <span class="control-more-trigger" :class="{ 'is-disabled': isControlPending(scope.row.ebikeId) }">
              <i class="el-icon-more" :class="{ 'el-icon-loading': isControlPending(scope.row.ebikeId) }"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="iot">IOT</el-dropdown-item>
              <el-dropdown-item command="maintain">{{ $t('tabmenu.name68') }}</el-dropdown-item>
              <el-dropdown-item
                v-if="buttonPerms.indexOf('ebikeControl/remoteUnlockBattery') > -1"
                command="remoteUnlockBattery"
                :disabled="isControlPending(scope.row.ebikeId)"
              >{{ $t('bike.name590') }}</el-dropdown-item>
              <el-dropdown-item
                v-if="buttonPerms.indexOf('ebikeControl/remoteLockBattery') > -1"
                command="remoteLockBattery"
                :disabled="isControlPending(scope.row.ebikeId)"
              >{{ $t('bike.name591') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryInfo.pageNumber"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="queryInfo.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
    <AppDialog size="lg" :title="$t('tabmenu.name68')"
  :visible.sync="dialogVisible"
  width="80%"
  v-if="dialogVisible"
  :before-close="handleClose">
  <el-table :data="maintenanceRecordTableList" :span-method="objectSpanMethod" :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }" v-loading="tableLoading1">
      <el-table-column :label="$t('bike.name105')" prop="tenantName" sortable></el-table-column>
      <el-table-column :label="$t('bike.name450')" prop="id" sortable width="200"> </el-table-column>
      <el-table-column :label="$t('bike.name451')" prop="userName" sortable> </el-table-column>
      <el-table-column :label="$t('bike.name452')" prop="storeAddress" sortable></el-table-column>
      <el-table-column :label="$t('bike.name453')" prop="createTime" sortable>
        <template slot-scope="scope">
          {{ scope.row.createTime | tzDisplay }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('bike.name278')" prop="ebikeCode" sortable> </el-table-column>
      <el-table-column :label="$t('bike.name38')" prop="ebikeId" sortable> </el-table-column>
      <el-table-column :label="$t('bike.name454')" prop="maintainTypeName" sortable> </el-table-column>
      <el-table-column :label="$t('bike.name455')" prop="oldPartCode" sortable> </el-table-column>
      <el-table-column :label="$t('bike.name456')" prop="newPartCode" sortable> </el-table-column>
      <el-table-column :label="$t('bike.name457')" prop="filePathList" sortable>
        <template slot-scope="scope" v-if="scope.row.filePathList.length > 0">
          <el-image style="width: 50px; height: 50px" :src="scope.row.filePathList[0]" :preview-src-list="scope.row.filePathList"></el-image>
        </template>
      </el-table-column>
    </el-table>
</AppDialog>
<AppDialog size="lg" :title="$t('tabmenu.name69')"
  :visible.sync="dialogVisible2"
  v-if="dialogVisible2"
  width="80%"
  :before-close="handleClose">
  <el-table :data="salesRecordTableList" :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }" v-loading="tableLoading1">
    <el-table-column :label="$t('bike.name29')" prop="createTime" sortable>
      <template slot-scope="scope">
        {{ scope.row.createTime | tzDisplay }}
      </template>
    </el-table-column>
      <el-table-column :label="$t('bike.name105')" prop="tenantName" sortable></el-table-column>
      <el-table-column :label="$t('bike.name452')" prop="storeAddress" sortable> </el-table-column>
      <el-table-column :label="$t('bike.name451')" prop="userName" sortable> </el-table-column>
      <el-table-column :label="$t('bike.name458')" prop="saleDate" sortable>
        <template slot-scope="scope">
          {{ scope.row.saleDate | tzDisplay }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('bike.name278')" prop="ebikeCode" sortable> </el-table-column>
      <el-table-column :label="$t('bike.name459')" prop="invoicePath" sortable>
        <template slot-scope="scope" v-if="scope.row.invoicePath">
          <el-image style="width: 50px; height: 50px" :src="scope.row.invoicePath" :preview-src-list="[scope.row.invoicePath]"></el-image>
        </template>
      </el-table-column>
    </el-table>
</AppDialog>
 <!--车辆详情-->
<VehicleDetailsAppDialog
  ref="vehicleDetailsDialog"
  :visible.sync="eBikeDetailsDialog"
  :e-bike-id="eBikeBaseInfo.ebikeId"
  :e-bike-code="eBikeBaseInfo.ebikeCode"
  :type="type"
  @list-changed="queryList"
/>
      <!--合格证-->
      <AppDialog size="lg" :visible.sync="certificateDialog" v-if="certificateDialog" :before-close="closeCertificateDialog">
      <CertificateDialog :certificate-details="certificateDetails"></CertificateDialog>
    </AppDialog>
     <!--IOT详情-->
     <AppDialog size="lg" :title="$t('bike.name254')" :visible.sync="iotDetailsDialog" v-if="iotDetailsDialog" :before-close="iotClose">
      <IotDetailsDialog ref="iotDetailsDialogRef" :ebike-id="iotEbikeId"></IotDetailsDialog>
      <template #footer>
        <el-button @click="iotClose">{{ $t('public.name14') }}</el-button>
      </template>
    </AppDialog>
       <!--分配归属-->
       <AppDialog size="sm" :title="$t('bike.name156')" :visible.sync="addIotNumDialog" v-if="addIotNumDialog" :before-close="closeBelong" >
      <el-form ref="belongFormRef"  :label-width="formLabelWidth('lg2')" :rules="belongFormRules"  :model="belong">
        <el-form-item :label="$t('bike.name160')"  prop="tenantId">
            <el-cascader ref="refHandle" v-model="belong.tenantId" :placeholder="$t('public.name1')" :show-all-levels="false" @change="handleChange1" :props="{ lazy: true, checkStrictly: true, lazyLoad: loadOptions1 }" clearable></el-cascader>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button type="primary" @click="submitBelong" :loading="loading2">{{ $t('public.name13') }}</el-button>
        <el-button @click="closeBelong">{{ $t('public.name14') }}</el-button>
      </template>
    </AppDialog>
      <!--导入车辆出厂信息-->
      <AppDialog size="sm" :title="$t('bike.name400')" :visible.sync="bikeFactoryUploadDialog" v-if="bikeFactoryUploadDialog" :before-close="closeBikeUpload" >
      <el-form class="factory-upload-form" :label-width="formLabelWidth('xxl')">
        <el-form-item :label="$t('bike.name100')">
          <a :href="importFactoryInformationPath">
            <el-button type="primary">{{ $t('bike.name101') }}</el-button>
          </a>
        </el-form-item>
        <el-form-item :label="$t('bike.name150')" prop="uploadTenantId">
          <el-select v-model="uploadTenantId" :placeholder="$t('public.name1')">
    <el-option
      v-for="item in manufacturerOptions"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
          </el-form-item>
        <el-form-item :label="$t('bike.name403')">
          <el-button type="primary" @click="handleManualUpload">{{ $t('bike.name103') }}</el-button>
          <input type="file" style="display: none" ref="fileInput" @change="handleFileChange">
          <el-upload
          ref="upload"
          action=""
          :limit="1"
          :before-upload="handleBeforeUpload">
        </el-upload>

         <div class="file-list" v-if="fiveWayCodeFile">
          <div>{{ fiveWayCodeFile.name }}</div>
          <div><i class="el-icon-close" @click="delFile"></i></div>
         </div>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button type="primary" @click="uploadSectionFile6" :loading="loading3">{{ $t('public.name13') }}</el-button>
        <el-button @click="closeBikeUpload">{{ $t('public.name14') }}</el-button>
      </template>
    </AppDialog>

      <!--修改车辆出厂信息-->
      <AppDialog size="sm" :title="$t('bike.name402')" :visible.sync="editEbikeInfoDialog" v-if="editEbikeInfoDialog" :before-close="closeBikeUpload" >
      <el-form class="factory-upload-form" :label-width="formLabelWidth('xxl')">
        <el-form-item :label="$t('bike.name100')">
          <a :href="modifyFactoryInformationPath">
            <el-button type="primary">{{ $t('bike.name101') }}</el-button>
          </a>
        </el-form-item>
        <el-form-item :label="$t('bike.name150')" prop="uploadTenantId">
          <el-select v-model="uploadTenantId" :placeholder="$t('public.name1')">
    <el-option
      v-for="item in manufacturerOptions"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
          </el-form-item>
        <el-form-item :label="$t('bike.name403')">
          <el-button type="primary" @click="handleManualUpload">{{ $t('bike.name103') }}</el-button>
          <input type="file" style="display: none" ref="fileInput" @change="handleFileChange" id="fileInput">
          <el-upload
          ref="upload"
          action=""
          :limit="1"
          :before-upload="handleBeforeUpload">
        </el-upload>

         <div class="file-list" v-if="fiveWayCodeFile">
          <div>{{ fiveWayCodeFile.name }}</div>
          <div><i class="el-icon-close" @click="delFile"></i></div>
         </div>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button type="primary" @click="uploadExcelRecord" :loading="loading4">{{ $t('bike.name569') }}</el-button>
        <el-button type="primary" @click="uploadSectionFile7" :loading="loading3">{{ $t('public.name13') }}</el-button>
        <el-button @click="closeBikeUpload">{{ $t('public.name14') }}</el-button>
      </template>
    </AppDialog>

      <!--整车修改导入EXCEL记录-->
      <AppDialog size="md" :title="$t('bike.name402')" :visible.sync="ebikeUploadExcelDialog" v-if="ebikeUploadExcelDialog" :before-close="closeBikeUploadExcel" >
       <el-table ref="uploadTable" :data="tableList1" :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }" v-loading='tableLoading2'>
      <el-table-column :label="$t('bike.name570')" prop="createTime" sortable>
        <template slot-scope="scope">
          {{ scope.row.createTime | tzDisplay }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('manage.name62')" prop="loginName" sortable></el-table-column>
      <el-table-column :label="$t('bike.name571')" prop="fileUrl" sortable></el-table-column>
      <el-table-column :label="$t('bike.name11')" width="100" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" @click="downloadFileExcel(scope.row.fileUrl)">{{ $t('bike.name572') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
      <template #footer>
       <el-pagination
      background
      @size-change="handleExcelSizeChange"
      @current-change="handleExcelCurrentChange"
      :current-page="queryEbikeUpload.pageNumber"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="queryEbikeUpload.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="ebikeUploadTotal"
    >
    </el-pagination>
      </template>
    </AppDialog>
  </div>
</template>
<script>
import { tenantList } from '@/api/manage.js'
import {
  ebikeCertificateConformity,
  queryWebMaintainRecordListByEbikeCode,
  querySaleListByEbikeCode,
  fullEbikeCcc,
  fullEbikeFactory,
  selecteById,
  tenantBindEbike,
  importEbikeModelCertificateConformity,
  downloadTempFile,
  importEditEbikeInfo,
  queryEbikeUploadPage,
  remoteDisable,
  remoteEnable,
  remoteUnlockBattery,
  remoteLockBattery,
  getHandleResult
} from '@/api/bike.js'
import { downloadExcel } from '@/utils/utils'
import CertificateDialog from '../bikemanage/certificateDialog.vue'
import VehicleDetailsAppDialog from '@/components/VehicleDetailsAppDialog.vue'
import IotDetailsDialog from '../components/IotDetailsDialog.vue'
import AppDialog from '@/components/AppDialog/index.vue'
import { clearFormValidateOnLangChange } from '@/utils/i18nFormHelpers.js'
import { isOverseas } from '@/config/flavor'
export default {
  data() {
    return {
      isOverseas,
      // ebikeId -> true：该车远程指令轮询中
      controlPending: {},
      controlTimers: {},
      // ebikeId -> 当前操作文案，失败提示用
      controlActionLabel: {},
      importFactoryInformationPath: 'https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/%E5%AF%BC%E5%85%A5%E8%BD%A6%E8%BE%86%E5%87%BA%E5%8E%82%E4%BF%A1%E6%81%AF-%E6%A8%A1%E6%9D%BFv10.xlsx',
      modifyFactoryInformationPath: 'https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/%E4%BF%AE%E6%94%B9%E8%BD%A6%E8%BE%86%E5%87%BA%E5%8E%82%E4%BF%A1%E6%81%AF-%E6%A8%A1%E6%9D%BFv3.xlsx',
      tenantIds: [],
      loading: false,
      certificateDialog: false,
      editEbikeInfoDialog: false,
      ebikeUploadTotal: 0,
      queryEbikeUpload: {
        pageSize: 10,
        pageNumber: 1,
      },
      tableList1: [],
      tableLoading2: false,
      queryInfo: {
        pageNumber: 1,
        pageSize: 10,
        tenantId: '',
        ebikeId: '',
        ebikeCode: '',
        ebikeModelId: '',
        searchTime: [],
        startDate: '',
        endDate: '',
        saleStatus: ''
      },
      total: 0,
      buttonPerms: '',
      tenantOptions: [],
      tableList: [],
      srcList: [],
      tableLoading: false,
      dialogVisible: false,
      dialogVisible2: false,
      maintenanceRecordTableList: [],
      tableLoading1: false,
      spanArr: [],
      pos: 0,
      salesRecordTableList: [],
      eBikeDetailsDialog: false,
      certificateDetails: {},
      eBikeBaseInfo: {
        ebikeId: '',
        ebikeCode: ''
      },
      type: 4,
      loading4: false,
      iotDetailsDialog: false,
      iotEbikeId: '',
      addIotNumDialog: false,
      belong: {
        tenantId: []
      },
      selectionList: [],
      loading2: false,
      bikeFactoryUploadDialog: false,
      fiveWayCodeFile: null,
      uploadTenantId: '',
      manufacturerOptions: [],
      loading3: false,
      loadingVehicle: false,
      ebikeUploadExcelDialog: false,
    }
  },
  components: {
    CertificateDialog,
    VehicleDetailsAppDialog,
    IotDetailsDialog,
    AppDialog
  },
  created () {
    const lang = localStorage.getItem('lang')
    this.updateImportTemplatePaths(lang)
    this.buttonPerms = localStorage.getItem('buttonPerms')
    this.getTenantList()
  },
  beforeDestroy() {
    this.$bus.$off('lang', this.handleLangChange)
    this.clearAllControlTimers()
  },
  mounted() {
    this.$bus.$on('lang', this.handleLangChange)
    this.getTenantList()
    this.getPageList()
  },
  computed: {
    // 海外三点菜单：有电池锁权限或始终可点 IOT/维修（菜单本身常显）
    showOverseasMoreMenu () {
      return true
    },
    saleStatusOptions () {
      return [
        { label: this.$t('bike.name312'), value: '0' },
        { label: this.$t('bike.name311'), value: '1' }
      ]
    },
    belongFormRules () {
      return {
        tenantId: [{ required: true, message: this.$t('public.name45'), trigger: 'blur' }]
      }
    }
  },
  methods: {
    updateImportTemplatePaths (lang) {
      if (lang === 'en') {
        this.importFactoryInformationPath = 'https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/Import%20the%20vehicle%27s%20factory%20information-v10.xlsx'
        this.modifyFactoryInformationPath = 'https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/Modify%20the%20factory%20information%20of%20the%20vehicle-v3.xlsx'
      } else {
        this.importFactoryInformationPath = 'https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/%E5%AF%BC%E5%85%A5%E8%BD%A6%E8%BE%86%E5%87%BA%E5%8E%82%E4%BF%A1%E6%81%AF-%E6%A8%A1%E6%9D%BFv10.xlsx'
        this.modifyFactoryInformationPath = 'https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/%E4%BF%AE%E6%94%B9%E8%BD%A6%E8%BE%86%E5%87%BA%E5%8E%82%E4%BF%A1%E6%81%AF-%E6%A8%A1%E6%9D%BFv3.xlsx'
      }
    },
    handleLangChange (lang) {
      this.updateImportTemplatePaths(lang)
      clearFormValidateOnLangChange(this, ['belongFormRef'])
    },
    /** daterange 浏览器本地 → 账号时区 yyyy-MM-dd，供 manufacture_date 查询 */
    syncAccountDateRange() {
      if (this.queryInfo.searchTime && this.queryInfo.searchTime.length === 2) {
        const { startDate, endDate } = this.$tz.dateRangeToAccountDates(this.queryInfo.searchTime)
        this.queryInfo.startDate = startDate
        this.queryInfo.endDate = endDate
      } else {
        this.queryInfo.startDate = ''
        this.queryInfo.endDate = ''
      }
    },
    showDetailsDialog(row) {
      this.eBikeBaseInfo.ebikeId = row.ebikeId
      this.eBikeBaseInfo.ebikeCode = row.ebikeCode
      this.eBikeDetailsDialog = true
    },
    downloadFileExcel (url) {
      window.open(url)
    },
    uploadExcelRecord () {
      this.ebikeUploadExcelDialog = true
      this.queryEbikeUpload.pageNumber = 1
      this.queryExcelUploadList()
    },
    async queryExcelUploadList () {
      this.tableLoading2 = true
      try {
        const res = await queryEbikeUploadPage({
          pageNumber: this.queryEbikeUpload.pageNumber,
          pageSize: this.queryEbikeUpload.pageSize
        })
        if (res && res.code === 200) {
          this.tableList1 = (res.data && res.data.page && res.data.page.records) || []
          this.ebikeUploadTotal = (res.data && res.data.page && res.data.page.total) || 0
        } else {
          this.tableList1 = []
          this.ebikeUploadTotal = 0
        }
      } catch (e) {
        this.tableList1 = []
        this.ebikeUploadTotal = 0
      } finally {
        this.tableLoading2 = false
      }
    },
    handleExcelSizeChange(newSize) {
      this.queryEbikeUpload.pageSize = newSize
      this.queryEbikeUpload.pageNumber = 1
      this.queryExcelUploadList()
    },
    handleExcelCurrentChange(newPage) {
      this.queryEbikeUpload.pageNumber = newPage
      this.queryExcelUploadList()
    },
    closeBikeUploadExcel() {
      this.ebikeUploadExcelDialog = false
    },
    showCertificateDialog(row) {
      selecteById({ id: row.eccId })
        .then(res => {
          this.certificateDetails = res.data || {}
        })
        .catch(res => {
          this.certificateDetails = {}
        })
      this.certificateDialog = true
    },
    showIotDetailsDialog(row) {
      this.iotEbikeId = row.ebikeId
      this.iotDetailsDialog = true
    },
    iotClose() {
      if (this.$refs.iotDetailsDialogRef) {
        this.$refs.iotDetailsDialogRef.close()
      }
      this.iotDetailsDialog = false
      this.iotEbikeId = ''
    },
    closeEBikeDialog() {
      if (this.$refs.vehicleDetailsDialog) {
        this.$refs.vehicleDetailsDialog.close()
      }
      this.eBikeDetailsDialog = false
      this.eBikeBaseInfo = {
        ebikeId: '',
        ebikeCode: ''
      }
    },
    closeCertificateDialog() {
      this.certificateDialog = false
    },
    showAddIotNum() {
      if (this.selectionList.length === 0) {
        this.$message.warning(this.$t('bike.name380'))
        return
      }
      this.addIotNumDialog = true
    },
    onSelectTab(selection) {
      this.selectionList = selection
    },
    /** 表格 row-key：eccId 为后端返回的字符串主键，避免 JS 大整数精度问题 */
    getCertificateRowKey(row) {
      return row.eccId || row.ebikeId || String(row.id)
    },
    /** 导出时读取表格实际选中行（优先 store，兼容 selectionList 未同步的情况） */
    getSelectedCertificateRows() {
      const table = this.$refs.certificateTable
      const storeSelection = table && table.store && table.store.states && table.store.states.selection
      if (storeSelection && storeSelection.length) {
        return storeSelection
      }
      return this.selectionList
    },
    /**
     * 构建整车列表导出筛选参数（CCC 物料 / 整车出厂共用）。
     * 仅决定查哪些行，不决定 Excel 列；列由 fullEbikeCcc 与 fullEbikeFactory 各自的后端 DTO 生成。
     */
    buildCertificateListExportFilter() {
      const selectedRows = this.getSelectedCertificateRows()
      if (selectedRows.length > 0) {
        const eccIdList = selectedRows.map((item) => item.eccId).filter(Boolean)
        if (!eccIdList.length) {
          return null
        }
        const filter = { eccIdList }
        if (this.queryInfo.tenantId) {
          filter.tenantId = this.queryInfo.tenantId
        }
        return filter
      }
      this.syncAccountDateRange()
      const { searchTime, ...query } = this.queryInfo
      return { ...query }
    },
    submitBelong() {
      this.$refs.belongFormRef.validate((valid) => {
        if (valid) {
          this.$confirm(this.$t('public.name32'), this.$t('public.name23'), {
            confirmButtonText: this.$t('public.name25'),
            cancelButtonText: this.$t('public.name14'),
            type: 'warning'
          })
            .then(() => {
              this.loading2 = true
              const ebikeIdList = []
              this.selectionList.map((item, index) => {
                ebikeIdList.push(item.ebikeId)
              })
              tenantBindEbike({ ebikeIdList: ebikeIdList, tenantId: this.belong.tenantId })
                .then((res) => {
                  console.log('res====', res)
                  this.loading2 = false
                  if (res.code === 200) {
                    this.$refs.certificateTable.clearSelection()
                    this.closeBelong()
                    this.queryList()
                  }
                })
                .catch(() => {
                  this.loading2 = false
                })
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: this.$t('public.name33')
              })
            })
        } else {
          return false
        }
      })
    },
    closeBelong() {
      this.addIotNumDialog = false
      this.belong.tenantId = ''
    },
    importBikeFactoryDialog() {
      this.loadOptions2()
      this.bikeFactoryUploadDialog = true
    },
    closeBikeUpload() {
      this.bikeFactoryUploadDialog = false
      this.editEbikeInfoDialog = false
      this.fiveWayCodeFile = null
    },
    loadOptions2() {
      const data = {
        page: 1,
        limit: 500,
        tenantType: 1
      }
      tenantList(data)
        .then(res => {
          if (res.data.list) {
            const options = res.data.list.map(item => ({
              value: item.tenantId,
              label: item.tenantName
            }))
            this.manufacturerOptions = options
            this.uploadTenantId = this.manufacturerOptions[0].value
          } else {
            this.manufacturerOptions = []
          }
        })
        .catch(() => {})
    },
    handleBeforeUpload(file) {
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error(this.$t('public.name36'))
        return false
      }
      return true
    },
    handleManualUpload() {
      this.$refs.fileInput.click()
    },
    handleFileChange(e) {
      this.fiveWayCodeFile = e.target.files[0]
      e.target.value = ''
    },
    delFile() {
      this.fiveWayCodeFile = null
    },
    importEditEbikeInfo() {
      this.loadOptions2()
      this.editEbikeInfoDialog = true
    },
    uploadSectionFile6() {
      if (this.fiveWayCodeFile === null && this.uploadTenantId !== '') {
        this.$message.error(this.$t('bike.name392'))
        return
      }
      const formData = new FormData()
      formData.append('file', this.fiveWayCodeFile)
      formData.append('tenantId', this.uploadTenantId)
      this.loading3 = true
      importEbikeModelCertificateConformity(formData)
        .then((res) => {
          this.loading3 = false
          if (res.code === 200) {
            if (res.data) {
              downloadTempFile({ objectName: res.data })
                .then((res) => {
                  this.$confirm(this.$t('bike.name399'), this.$t('public.name23'), {
                    confirmButtonText: this.$t('public.name37'),
                    cancelButtonText: this.$t('public.name14'),
                    type: 'warning'
                  })
                    .then(() => {
                      downloadExcel(res, this.$t('bike.name400'), 'xlsx', true)
                    })
                    .catch(() => {})
                })
                .catch((res) => {})
            } else {
              this.$message.success(this.$t('bike.name401'))
            }
          }
          this.$refs.certificateTable.clearSelection()
          this.queryList()
          this.bikeFactoryUploadDialog = false
          this.uploadTenantId = this.manufacturerOptions[0].value
          this.fiveWayCodeFile = null
        })
        .catch((res) => {
          this.loading3 = false
        })
    },
    uploadSectionFile7() {
      if (this.fiveWayCodeFile === null && this.uploadTenantId !== '') {
        this.$message.error(this.$t('bike.name392'))
        return
      }
      const formData = new FormData()
      formData.append('file', this.fiveWayCodeFile)
      formData.append('tenantId', this.uploadTenantId)
      this.loading3 = true
      importEditEbikeInfo(formData)
        .then((res) => {
          this.loading3 = false
          if (res.code === 200) {
            if (res.data) {
              downloadTempFile({ objectName: res.data })
                .then((res) => {
                  this.$confirm(this.$t('bike.name460'), this.$t('public.name23'), {
                    confirmButtonText: this.$t('public.name37'),
                    cancelButtonText: this.$t('public.name14'),
                    type: 'warning'
                  })
                    .then(() => {
                      downloadExcel(res, this.$t('bike.name402'), 'xlsx', true)
                    })
                    .catch(() => {})
                })
                .catch((res) => {})
            } else {
              this.$message.success(this.$t('bike.name461'))
            }
          }
          this.$refs.certificateTable.clearSelection()
          this.queryList()
          this.editEbikeInfoDialog = false
          this.uploadTenantId = this.manufacturerOptions[0].value
          this.fiveWayCodeFile = null
        })
        .catch((res) => {
          this.loading3 = false
        })
    },
    resetQuery() {
      this.queryInfo = {
        pageNumber: 1,
        pageSize: 10,
        tenantId: '',
        ebikeId: '',
        ebikeCode: '',
        ebikeModelId: '',
        searchTime: [],
        startDate: '',
        endDate: '',
        saleStatus: ''
      }
      this.tenantIds = []
      this.queryList()
    },
    getPageList() {
      this.queryInfo.pageNumber = 1
      this.queryInfo.pageSize = 10
      this.queryList()
    },
    buildCertificateListParams(pageNumber, pageSize) {
      this.syncAccountDateRange()
      return {
        ...this.queryInfo,
        pageNumber,
        pageSize
      }
    },
    async queryList() {
      this.tableLoading = true
      try {
        const params = this.buildCertificateListParams(this.queryInfo.pageNumber, this.queryInfo.pageSize)
        const res = await ebikeCertificateConformity(params)
        if (res && res.code === 200) {
          this.tableList = (res.data && res.data.page && res.data.page.records) || []
          this.total = (res.data && res.data.page && res.data.page.total) || 0
        } else {
          this.tableList = []
          this.total = 0
        }
      } catch (e) {
        this.tableList = []
        this.total = 0
      } finally {
        this.tableLoading = false
      }
    },
    getCertificateList() {
      return this.queryList()
    },
    getTenantList() {
      const data = {
        page: 1,
        limit: 500,
        tenantType: 2
      }
      tenantList(data)
        .then(res => {
          this.tenantOptions = res.data.list
        })
        .catch(() => {
          this.tenantOptions = []
        })
    },
    loadOptions1(node, resolve) {
      if (node.level === 3) {
        resolve([])
        return
      }
      let data = {
        page: 1,
        limit: 500,
        tenantType: 1
      }
      if (node.level === 1) {
        data = {
          page: 1,
          limit: 500,
          tenantType: 2,
          parentId: node.value
        }
      }
      if (node.level === 2) {
        data = {
          page: 1,
          limit: 500,
          tenantType: 3,
          parentId: node.value
        }
      }
      tenantList(data)
        .then(res => {
          if (res.data.list) {
            const options = res.data.list.map(item => ({
              value: item.tenantId,
              label: item.tenantName,
              leaf: node.level >= 2
            }))
            resolve(options)
          } else {
            resolve([])
          }
        })
        .catch(() => {})
    },
    handleChange1(value) {
      this.belong.tenantId = value[value.length - 1]
      const panelRefs = this.$refs.refHandle.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.activePath.forEach(item => {
          if (item.children.length === 0) {
            panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
          }
        })
      }
    },
    loadOptions(node, resolve) {
      if (node.level === 2) {
        resolve([])
        return
      }
      let data = {
        page: 1,
        limit: 500,
        tenantType: 1
      }

      if (node.level === 1) {
        data = {
          page: 1,
          limit: 500,
          tenantType: 2,
          parentId: node.value
        }
      }

      tenantList(data)
        .then(res => {
          if (res.data.list) {
            const options = res.data.list.map(item => ({
              value: item.tenantId,
              label: item.tenantName,
              leaf: node.level >= 1
            }))
            resolve(options)
          } else {
            resolve([])
          }
        })
        .catch(() => {})
    },
    handleChange(value) {
      // 处理选项变化
      this.queryInfo.tenantId = value[value.length - 1]
      const panelRefs = this.$refs.refHandle.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.activePath.forEach(item => {
          if (item.children.length === 0) {
            panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
          }
        })
      }
    },
    showMaintenanceRecord(row) {
      this.dialogVisible = true
      this.tableLoading1 = true
      queryWebMaintainRecordListByEbikeCode({ ebikeCode: row.ebikeCode }).then(res => {
        this.tableLoading1 = false
        if (res.code === 200) {
          this.maintenanceRecordTableList = res.data
          this.spanArr = []
          this.pos = 0
          this.getSpanArr(this.maintenanceRecordTableList)
        }
      }).catch(() => {
        this.maintenanceRecordTableList = []
        this.tableLoading1 = false
      })
    },
    getSpanArr(data) {
      for (var i = 0; i < data.length; i++) {
        if (i === 0) {
          this.spanArr.push(1)
          this.pos = 0
        } else {
          // 判断当前元素与上一个元素是否相同
          if (
            data[i].id === data[i - 1].id &&
            data[i].tenantName === data[i - 1].tenantName &&
            data[i].userName === data[i - 1].userName &&
            data[i].createTime === data[i - 1].createTime &&
            data[i].ebikeCode === data[i - 1].ebikeCode &&
            data[i].ebikeId === data[i - 1].ebikeId &&
            data[i].storeAddress === data[i - 1].storeAddress
          ) {
            this.spanArr[this.pos] += 1
            this.spanArr.push(0)
          } else {
            this.spanArr.push(1)
            this.pos = i
          }
        }
      }
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0 || columnIndex === 1 || columnIndex === 2 || columnIndex === 3 || columnIndex === 4 || columnIndex === 5 || columnIndex === 6 || columnIndex === 10) {
        const _row = this.spanArr[rowIndex]
        const _col = _row > 0 ? 1 : 0
        return {
          // [0,0] 表示这一行不显示， [2,1]表示行的合并数
          rowspan: _row,
          colspan: _col
        }
      }
    },
    showSalesRecord(row) {
      this.dialogVisible2 = true
      this.tableLoading1 = true
      querySaleListByEbikeCode({ ebikeCode: row.ebikeCode }).then(res => {
        this.tableLoading1 = false
        if (res.code === 200) {
          this.salesRecordTableList = res.data
        }
      }).catch(() => {
        this.salesRecordTableList = []
        this.tableLoading1 = false
      })
    },
    handleClose() {
      this.dialogVisible = false
      this.dialogVisible2 = false
    },
    // 监听pagesizes的事件
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize
      this.queryInfo.pageNumber = 1
      this.queryList()
    },
    // 监听页码值改变事件
    handleCurrentChange(newPage) {
      this.queryInfo.pageNumber = newPage
      this.queryList()
    },
    /** CCC 物料导出：列由 fullEbikeCcc → FullEbikeExportResponse 生成（含销售状态等） */
    exportCcc() {
      const filter = this.buildCertificateListExportFilter()
      if (!filter) {
        this.$message.warning(this.$t('bike.name380'))
        return
      }
      this.loading = true
      fullEbikeCcc(filter).then(res => {
        this.loading = false
        downloadExcel(res, this.$t('bike.name462'))
      }).catch(() => {
        this.loading = false
      })
    },
    /** 整车出厂信息导出：列由 fullEbikeFactory → FullEbikeFactoryExportResponse 生成（含 IOT 版本等） */
    exportVehicle() {
      const filter = this.buildCertificateListExportFilter()
      if (!filter) {
        this.$message.warning(this.$t('bike.name380'))
        return
      }
      this.loadingVehicle = true
      fullEbikeFactory(filter).then(res => {
        this.loadingVehicle = false
        downloadExcel(res, this.$t('bike.name530'))
      }).catch(() => {
        this.loadingVehicle = false
      })
    },
    isControlPending (ebikeId) {
      return !!this.controlPending[ebikeId]
    },
    // 开关锁按钮：仅当具备「当前状态对应」的接口权限时显示
    // 0→开启远程锁定需 remoteDisable(R1)；非 0→关闭远程锁定需 remoteEnable(R2)
    canToggleLockFor (lockStatus) {
      const perm = lockStatus === 0
        ? 'ebikeControl/remoteDisable'
        : 'ebikeControl/remoteEnable'
      return this.buttonPerms.indexOf(perm) > -1
    },
    // 列文案：0 解锁 / 4 远程锁定中 / 其它锁车
    lockStatusLabel (lockStatus) {
      if (lockStatus === 0) return this.$t('bike.name224')
      if (lockStatus === 4) return this.$t('bike.name601')
      return this.$t('bike.name225')
    },
    // 开关锁按钮：状态开锁(0)→关锁；否则→开锁
    // 解锁态 → 开启远程锁定(R1/remoteDisable)；锁定态 → 关闭远程锁定(R2/remoteEnable)
    toggleLockLabel (lockStatus) {
      return lockStatus === 0 ? this.$t('bike.name603') : this.$t('bike.name604')
    },
    // 开关锁：按当前状态选 remoteDisable / remoteEnable
    handleToggleLock (row) {
      if (!this.canToggleLockFor(row.lockStatus)) return
      const command = row.lockStatus === 0 ? 'remoteDisable' : 'remoteEnable'
      const actionLabel = this.toggleLockLabel(row.lockStatus)
      this.confirmAndExecuteControl(command, row, actionLabel)
    },
    // 海外三点：iot / maintain 为本地跳转；电池锁走远程指令
    handleOverseasMenuCommand (command, row) {
      if (command === 'iot') {
        this.showIotDetailsDialog(row)
        return
      }
      if (command === 'maintain') {
        this.showMaintenanceRecord(row)
        return
      }
      const actionLabelMap = {
        remoteUnlockBattery: this.$t('bike.name590'),
        remoteLockBattery: this.$t('bike.name591')
      }
      this.confirmAndExecuteControl(command, row, actionLabelMap[command])
    },
    confirmAndExecuteControl (command, row, actionLabel) {
      if (this.isControlPending(row.ebikeId)) {
        this.$message.warning(this.$t('bike.name598'))
        return
      }
      const confirmMsg = this.$t('bike.name599', { ebikeId: row.ebikeId, action: actionLabel })
      this.$confirm(confirmMsg, this.$t('public.name23'), {
        confirmButtonText: this.$t('public.name25'),
        cancelButtonText: this.$t('public.name14'),
        type: 'warning'
      }).then(() => {
        this.executeControl(command, row, actionLabel)
      }).catch(() => {})
    },
    executeControl (command, row, actionLabel) {
      const ebikeId = row.ebikeId
      const data = { ebikeId }
      const apiMap = {
        remoteEnable,
        remoteDisable,
        remoteUnlockBattery,
        remoteLockBattery
      }
      const api = apiMap[command]
      if (!api) return
      this.$set(this.controlPending, ebikeId, true)
      this.$set(this.controlActionLabel, ebikeId, actionLabel || '')
      api(data).then(res => {
        if (res && res.code === 200 && res.data && res.data.msgId) {
          this.$message.info(this.$t('bike.name597'))
          this.pollHandleResult(ebikeId, res.data.msgId)
        } else {
          this.$set(this.controlPending, ebikeId, false)
          this.$message.error((res && res.errorMsg) || (actionLabel
            ? this.$t('bike.name606', { ebikeId, action: actionLabel })
            : this.$t('bike.name595', { ebikeId })))
        }
      }).catch(() => {
        this.$set(this.controlPending, ebikeId, false)
        this.$message.error(actionLabel
          ? this.$t('bike.name606', { ebikeId, action: actionLabel })
          : this.$t('bike.name595', { ebikeId }))
      })
    },
    // 轮询 getHandleResult：约每 3s，最多 3 次（~9s）
    pollHandleResult (ebikeId, msgId) {
      const MAX_RETRY = 3
      let retry = 0
      const poll = () => {
        getHandleResult({ msgId }).then(res => {
          if (res && res.code === 200 && res.data) {
            const result = res.data.result
            // 0：等待中 1：成功 2：失败
            if (result === 1) {
              this.finishControl(ebikeId, true)
              return
            }
            if (result === 2) {
              this.finishControl(ebikeId, false)
              return
            }
          } else {
            this.finishControl(ebikeId, null)
            return
          }
          retry += 1
          if (retry >= MAX_RETRY) {
            this.finishControl(ebikeId, null)
            return
          }
          this.controlTimers[ebikeId] = setTimeout(poll, 3000)
        }).catch(() => {
          retry += 1
          if (retry >= MAX_RETRY) {
            this.finishControl(ebikeId, null)
            return
          }
          this.controlTimers[ebikeId] = setTimeout(poll, 3000)
        })
      }
      this.controlTimers[ebikeId] = setTimeout(poll, 3000)
    },
    finishControl (ebikeId, success) {
      this.clearControlTimer(ebikeId)
      this.$set(this.controlPending, ebikeId, false)
      const actionLabel = this.controlActionLabel[ebikeId]
      delete this.controlActionLabel[ebikeId]
      if (success === true) {
        this.$message.success(this.$t('bike.name594', { ebikeId, action: actionLabel || '' }))
        // 开关锁成功后刷新列表，更新锁车状态列与按钮文案
        this.queryList()
      } else if (success === false) {
        // 对应功能失败：如「开锁失败」「解锁电池失败」
        const failText = actionLabel
          ? this.$t('bike.name606', { ebikeId, action: actionLabel })
          : this.$t('bike.name595', { ebikeId })
        this.$message.error(failText)
      } else {
        this.$message.warning(this.$t('bike.name596', { ebikeId }))
      }
    },
    clearControlTimer (ebikeId) {
      if (this.controlTimers[ebikeId]) {
        clearTimeout(this.controlTimers[ebikeId])
        delete this.controlTimers[ebikeId]
      }
    },
    clearAllControlTimers () {
      Object.keys(this.controlTimers || {}).forEach(ebikeId => {
        clearTimeout(this.controlTimers[ebikeId])
      })
      this.controlTimers = {}
    }
  }
}
</script>
<style lang="scss" scoped>
.productCertificate-container {
  display: flex;
  flex-direction: column;
  .file-list{
    width: 70%;
    display: flex;
    justify-content: space-between;
    margin-top: -25px;

    .el-icon-close{
      font-size: 18px;
    }
  }

  .dialog-title{
    margin-right: 30px;
  }
  .dialog-content{
    width: 100%;
    display: flex;
    flex-direction: column;
    .title{
      font-size: 30px;
      color: #000;
      width: 100%;
      text-align: center;
    }
    .sb-hgzbh{
      width: 100%;
      display: flex;
      justify-content: space-between;
    }
    .table-content{
      width: 100%;
      display: flex;
      flex-direction: column;
      margin-top: 10px;
    }
  }

  .col-view{
    width: 100%;
    display: flex;
    flex-direction: row;
    border-bottom: 1px solid #dcdddd;
    .col1{
      width: 30%;
      border-right: 1px solid #dcdddd;
      height: 40px;
      display: flex;
      align-items: center;
    }
    .col2{
      width: 70%;
      height: 40px;
      display: flex;
      align-items: center;
      .col2-row{
        display: flex;
        flex-direction: row;
        width: 100%;
        .col2-row1{
          width: 33%;
          border-right: 1px solid #dcdddd;
          height: 40px;
          display: flex;
          align-items: center;
        }
        .col2-row2{
          width: 33%;
          border-right: 1px solid #dcdddd;
          height: 40px;
          display: flex;
          align-items: center;
        }
        .col2-row3{
          height: 40px;
          width: 34%;
          display: flex;
          align-items: center;
        }
      }
    }
  }
  .col-view1{
    width: 100%;
    display: flex;
    flex-direction: row;
    .col1{
      width: 30%;
      border-right: 1px solid #dcdddd;
      height: 40px;
      display: flex;
      align-items: center;
    }
    .col2{
      width: 70%;
      height: 40px;
      display: flex;
      align-items: center;
      .col2-row{
        display: flex;
        flex-direction: row;
        width: 100%;
        .col2-row1{
          width: 33%;
          border-right: 1px solid #dcdddd;
          height: 40px;
          display: flex;
          align-items: center;
        }
        .col2-row2{
          width: 33%;
          border-right: 1px solid #dcdddd;
          height: 40px;
          display: flex;
          align-items: center;
        }
        .col2-row3{
          height: 40px;
          width: 34%;
          display: flex;
          align-items: center;
        }
      }
    }
  }
  .col-view3{
    width: 100%;
    display: flex;
    flex-direction: row;
    border-bottom: 1px solid #dcdddd;
    .col1{
      width: 54.6%;
      border-right: 1px solid #dcdddd;
      height: 40px;
      display: flex;
      align-items: center;
    }
    .col2{
      width: 45.4%;
      height: 40px;
      display: flex;
      align-items: center;
      .col2-row{
        display: flex;
        flex-direction: row;
        width: 100%;
        .col2-row1{
          width: 33%;
          border-right: 1px solid #dcdddd;
          height: 40px;
          display: flex;
          align-items: center;
        }
        .col2-row2{
          width: 33%;
          border-right: 1px solid #dcdddd;
          height: 40px;
          display: flex;
          align-items: center;
        }
        .col2-row3{
          height: 40px;
          width: 34%;
          display: flex;
          align-items: center;
        }
      }
    }
  }

  .row-style1 {
    border: 1px solid #dcdddd;
    border-bottom: none;
    width: 100%;
    display: flex;
    align-items: center;
    // background: #f5f5f5;
  }
  .row-style2 {
    border: 1px solid #dcdddd;
    border-bottom: none;
    height: 40px;
    width: 100%;
    display: flex;
    align-items: center;
  }

  .row-style3 {
    border: 1px solid #dcdddd;
    border-top: none;
    height: 40px;
    width: 100%;
    display: flex;
    align-items: center;
  }
  .col-style {
    border-right: 1px solid #dcdddd;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .col-style1 {
    border-right: 1px solid #dcdddd;
    height: 40px;
    display: flex;
    align-items: center;
  }

  .col-style2 {
    border-right: 1px solid #dcdddd;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;;
  }
  .col-style3 {
    border-right: 1px solid #dcdddd;
    border-bottom: 1px solid #dcdddd;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 80px;
  }
  .margin10 {
    padding-left: 10px;
  }
  .center{
    text-align: center;
  }
  .border-right{
    border-right: 1px solid #dcdddd;
  }
  .green {
    width: 54px;
    height: 24px;
    text-align: center;
    border-radius: 2px;
    background: #ebf6ed;
    color: #39ab4c;
  }

  .red {
    width: 54px;
    height: 24px;
    text-align: center;
    border-radius: 2px;
    background: #fcecec;
    color: #ea4646;
  }

  .control-more-trigger {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    margin-left: 8px;
    color: #0f73e6;
    cursor: pointer;
    vertical-align: middle;
    &:hover {
      color: #409eff;
    }
    &.is-disabled {
      color: #c0c4cc;
      cursor: not-allowed;
    }
  }
}
</style>
